import { axiosClient } from "../../../../Constant/apiConstant";
import {
  swalErrorMessage,
  swalSuccessMessage,
} from "../../../../Constant/swalMessage";
import {
  AddLeadsService,
  cloneProjectService,
  deleteProjectsService,
  editProjectsService,
  functionsExecuteService,
  getAdvanceSettingsService,
  getCeleryTasksService,
  getLeadDataService,
  getProjectByIdService,
  getProjectSheetsDataService,
  getProjectSheetsService,
  getProjectsService,
  getSearchService,
  saveAdvanceSettingsService,
  saveProjectsService,
  updateLeadsService,
  celeryTaskPromoteService,
  deleteLeadService,
  uploadMultipleFilesService,
  excelLeadDataService,
  workflowLeadDataService,
  saveProjectFolderService,
  getprojectQueueService,
  getprojectCompletedQueueService,
} from "../../services/projects.services";
import { projectsType } from "./projects.type";

export const getProjectsAction = () => async (dispatch) => {
  axiosClient.defaults.headers.common["projectId"] = null;
  const res = await getProjectsService();
  if (res) {
    await dispatch({
      type: projectsType.GET_PROJECTS_LIST,
      payload: res?.data,
    });
  }
  return res?.data;
};

export const getProjectByIdAction = (id) => async (dispatch) => {
  axiosClient.defaults.headers.common["projectId"] = id;
  let res = await getProjectByIdService(id);
  if (res) {
    await dispatch({
      type: projectsType.GET_SELECTED_PROJECT,
      payload: res?.data,
    });
    return res?.data;
  }
};

export const saveProjectsAction =
  (obj, swal = true) =>
  async (dispatch) => {
    let res = await saveProjectsService(obj);
    if (res.status === 200) {
      return res;
    } else {
      return res;
    }
  };

export const editProjectsAction =
  (obj, id, displayAlert = true) =>
  async (dispatch) => {
    const res = await editProjectsService(obj, id);
    if (res.status === 200) {
      return true;
    } else {
      if (displayAlert) swalErrorMessage(res.errMsg);
      return res;
    }
  };

export const deleteProjectsAction = (id) => async (dispatch) => {
  let res = await deleteProjectsService(id);
  if (res.status === 200) {
    // swalSuccessMessage(res.msg);
    return true;
  } else {
    swalErrorMessage(res.errMsg);
  }
};

export const getAdvanceSettingAction = (id) => async (dispatch) => {
  let res = await getAdvanceSettingsService(id);
  if (res) {
    await dispatch({
      type: projectsType.GET_ADVANCE_SETTING,
      payload: res?.data,
    });
  }
};

export const saveAdvanceSettingAction = (obj, id) => async (dispatch) => {
  let res = await saveAdvanceSettingsService(obj, id);
  if (res.status === 200) {
    swalSuccessMessage(res.msg);
    return res.status;
  } else {
    swalErrorMessage(res.errMsg);
  }
};

export const clearProjectReducer = () => async (dispatch) => {
  await dispatch({
    type: projectsType.CLEAR_PROJECT_REDUCER,
    payload: {},
  });
};

export const updateProjectAccessAction = (arr) => async (dispatch) => {
  await dispatch({
    type: projectsType.PROJECT_ACCESS,
    payload: arr,
  });
};

export const getProjectSheetsAction = async (data) => {
  const res = await getProjectSheetsService(data);
  if (res?.status === 200) return res?.data;
};

export const getProjectSheetsDataAction = async (
  paramsdata,
  projectId,
  filters
) => {
  const res = await getProjectSheetsDataService(paramsdata, projectId, filters);
  if (res?.status === 200) return res?.data;
};

export const AddLeadsAction = async (obj) => {
  const res = await AddLeadsService(obj);
  if (res.status === 200) {
    return res;
  } else {
    swalErrorMessage(res.errMsg);
  }
};

export const updateLeadsAction = async (id, obj) => {
  const res = await updateLeadsService(id, obj);
  if (res.status === 200) {
    return res;
  } else {
    swalErrorMessage(res.errMsg);
  }
};

export const getLeadsDataAction = (obj) => async (dispatch) => {
  try {
    const res = await getLeadDataService(obj);

    if (res?.status === 200) {
      await dispatch({
        type: projectsType.GET_LEADS_LIST,
        payload: res?.data,
      });
      return res;
    } else {
      swalErrorMessage(res?.errMsg);
    }
  } catch (error) {
    swalErrorMessage("Something went wrong!");
  }
};

export const getLeadsCountAction = (obj) => async (dispatch) => {
  try {
    const res = await getLeadDataService(obj);
    if (res?.status === 200) {
      await dispatch({
        type: projectsType.GET_LEADS_COUNT,
        payload: res?.count,
      });
      return res?.count;
    } else {
      swalErrorMessage(res?.errMsg);
    }
  } catch (error) {
    swalErrorMessage("Something went wrong!");
  }
};
export const exportLeadsDataAction = (obj) => async () => {
  try {
    const res = await getLeadDataService(obj);
    if (res?.status === 200) {
      return res?.data;
    } else {
      swalErrorMessage(res?.errMsg);
    }
  } catch (error) {
    swalErrorMessage("Something went wrong!");
  }
};

export const cloneProjectAction = (data) => async (dispatch) => {
  const res = await cloneProjectService(data);
  if (res?.status === 200) {
    return res.status;
  } else {
    swalErrorMessage(res?.errMsg);
  }
};

export const getSearchAction = (data) => async () => {
  const res = await getSearchService(data);
  if (res?.status === 200) {
    return res?.data;
  } else {
    swalErrorMessage("Something Went Wrong");
  }
};

export const getCeleryTasksAction = (data) => async (dispatch) => {
  const res = await getCeleryTasksService(data);
  if (res?.status === 200) return res?.data;
};

export const celeryTaskPromoteAction = (data) => async () => {
  const res = await celeryTaskPromoteService(data);
  if (res?.status === 200) {
    return res;
  } else {
    swalErrorMessage(res?.errMsg);
  }
};

export const deleteLeadsAction = (id) => async () => {
  const res = await deleteLeadService(id);
  if (res?.status === 200) {
    return res;
  } else {
    swalErrorMessage(res?.errMsg);
  }
};

export const functionsExecuteAction = (data) => async (dispatch) => {
  const res = await functionsExecuteService(data);

  if (res?.status === 200) {
    return res?.data;
  } else {
    swalErrorMessage(res?.errMsg);
  }
};

export const uploadMultipleFilesAction = (obj) => async () => {
  const res = await uploadMultipleFilesService(obj);
  if (res?.status === 200) {
    return res?.data;
  } else {
    swalErrorMessage(res?.errMsg);
  }
};

export const excelLeadDataAction = (payload) => async () => {
  const res = await excelLeadDataService(payload);
  return res;
};

export const workflowLeadDataAction = (payload) => async () => {
  const res = await workflowLeadDataService(payload);
  return res;
};

export const saveProjectFolderAction = (obj) => async () => {
  axiosClient.defaults.headers.common["projectId"] = null;
  const res = await saveProjectFolderService(obj);
  if (res.status === 200) {
    return res;
  } else {
    return res;
  }
};
export const getProjectQueueAction = () => async () => {
  const res = await getprojectQueueService();
  return res;
};
export const getProjectCompletedQueueAction = (obj) => async () => {
  const res = await getprojectCompletedQueueService(obj);
  if (res?.status === 200) return res?.data;
};
